export const getEventDate = (fechaEvento) => {
  if (!fechaEvento) return null;

  let date;

  if (typeof fechaEvento === "string") {
    const cleanDate = fechaEvento.trim().replace(/\//g, "-");

    date = new Date(cleanDate);

    if (isNaN(date.getTime())) {
      const parts = cleanDate.split("-");

      if (parts.length >= 3) {
        date = new Date(
          Number(parts[0]),
          Number(parts[1]) - 1,
          Number(parts[2].substring(0, 2))
        );
      }
    }
  } else {
    date = new Date(fechaEvento);
  }

  if (isNaN(date.getTime())) {
    return null;
  }

  return date;
};

export const getUpcomingEvents = (eventsFirebase) => {
  if (!eventsFirebase) return [];

  return Object.keys(eventsFirebase)
    .map((key) => ({
      ...eventsFirebase[key],
      firebaseKey: key,
    }))
    .filter((evento) => Number(evento.eventoDisponible) === 2)
    .sort((a, b) => {
      const fechaA = getEventDate(a.fechaEvento);
      const fechaB = getEventDate(b.fechaEvento);

      if (!fechaA && !fechaB) return 0;
      if (!fechaA) return 1;
      if (!fechaB) return -1;

      return fechaA.getTime() - fechaB.getTime();
    });
};

export const getLiveEvents = (eventsFirebase) => {
  if (!eventsFirebase) return [];

  return Object.keys(eventsFirebase)
    .map((key) => ({
      ...eventsFirebase[key],
      firebaseKey: key,
    }))
    .filter((evento) => Number(evento.eventoDisponible) === 4)
    .sort((a, b) => {
      const fechaA = getEventDate(a.fechaEvento);
      const fechaB = getEventDate(b.fechaEvento);

      if (!fechaA && !fechaB) return 0;
      if (!fechaA) return 1;
      if (!fechaB) return -1;

      return fechaB.getTime() - fechaA.getTime();
    });
};
